import { render, staticRenderFns } from "./savings_redeem.vue?vue&type=template&id=f3c4d0c2&scoped=true"
import script from "./savings_redeem.vue?vue&type=script&lang=js"
export * from "./savings_redeem.vue?vue&type=script&lang=js"
import style0 from "./savings_redeem.vue?vue&type=style&index=0&id=f3c4d0c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4d0c2",
  null
  
)

export default component.exports